module.exports = __webpack_public_path__ + "img/partner.3015c754.png";